import { defineStore } from 'pinia'
import { ref } from 'vue'
import { indexlist, getclassfiy, sharewx } from "../api/index";
let useDataInfo = defineStore('dataInfo',() => {
  // 数据
  const navList = ref([])//导航标签
  const articleContentList = ref([])
  const finishedText = ref()
  const docuTitle = ref()


  // 获取
  const navListInfo = async (pid) => {
    try {
      let res = await getclassfiy(pid)
      if(res.code === 1){
        document.title = res.data.title;
        res.data.datalist.unshift({ id: 0, name: "全部" });
        docuTitle.value = res.data.title;
        navList.value = res.data.datalist;
        // listInfo("",1,0,"")
      }
    } catch (error) {
      console.log(error)
    }
  }
  /**
   *
   * @param {*} val 搜索框中内容
   * @param {*} page 请求第一页的数据
   * @param {*} active 选中那个导航栏
   * @param {*} pid url地址上面的数据pid
   */
  const listInfo = async (val, page, active, pid) => {
    try {
      let res = await indexlist(val,page,active,pid)
      if(res.code === 1){
        articleContentList.value.push(...res.data.data);
        if (res.data.data.length === 0) {
           finishedText.value = "暂无数据";
        } else {
          if (res.data.total > articleContentList.value.length) {
            finishedText.value = "下滑刷新数据";
          } else {
            finishedText.value = "没有更多数据了";
          }
        }


        // if (res.data.total === articleContentList.length) {
        //   finishedText.value = "没有更多数据了";
        //   if (res.data.total === 0) {
        //     finishedText.value = "暂无数据";
        //   }
        // } else {
        //
        // }
      }
    } catch (error) {
      console.log(error)
    }
  }


  return {
    navList,
    articleContentList,
    finishedText,
    docuTitle,
    navListInfo,
    listInfo,
  }
})

export default useDataInfo
